module.exports = __webpack_public_path__ + "img/green-lock.209464bb.svg";